export enum SegmentCookieIdentifier {
  Accept = 'accept',
  Unaccept = 'unaccept',
}
